import {
  SetOrganizationUUID,
  SetDateRange,
  Type as ControlType,
} from '../Controls';

export interface State {
  isLoading: boolean;
  data?: SummaryData;
}

interface SummaryData {
  codeReviewCount: number;
  totalCommentCount: number;
}

export const initialState: State = {
  isLoading: true,
  data: undefined,
};

export enum SummaryType {
  SET_SUMMARY_DATA = 'COMMENTS/SUMMARY/SET_SUMMARY_DATA',
}

interface Action<T> {
  type: T;
}

export interface SetSummaryData extends Action<SummaryType.SET_SUMMARY_DATA> {
  data?: SummaryData;
}

type Actions = SetOrganizationUUID | SetDateRange | SetSummaryData;

export default (state = initialState, action: Actions): State => {
  switch (action.type) {
    case SummaryType.SET_SUMMARY_DATA:
      return {
        ...state,
        isLoading: false,
        data: action.data,
      };
    case ControlType.SET_ORGANIZATION_UUID:
    case ControlType.SET_DATE_RANGE:
      return {
        ...state,
        isLoading: true,
        data: undefined,
      };
    default:
      return state;
  }
};

export const actions = {
  setSummaryData: (data?: SummaryData): SetSummaryData => ({
    type: SummaryType.SET_SUMMARY_DATA,
    data,
  }),
};
